import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
import { Formik, Form } from "formik"; // import PropTypes from "prop-types";

import * as Yup from "yup";
import { Grid, Dialog, StepperHorizontal, makeStyles } from "../../..";
import { Debug } from "../../../Molecules/Forms/Debug";
var projectSchemaB2B = Yup.object().shape({
  name: Yup.string().min(2, "Too Short!").required("Campo obligatorio"),
  dateStart: Yup.date()["default"](function () {
    return new Date();
  }),
  dateEnd: Yup.date()["default"](function () {
    return new Date();
  }),
  type: Yup.string().required(),
  budget: Yup.number().required("Introduce un valor"),
  currency: Yup.string().required(),
  template: Yup.string().required(),
  projectType: Yup.string().required().min(3, "Selecciona un tipo antes de continuar")
});
var projectSchemaB2C = Yup.object().shape({
  name: Yup.string().min(2, "Too Short!").required("Campo obligatorio"),
  dateStart: Yup.date()["default"](function () {
    return new Date();
  }),
  dateEnd: Yup.date()["default"](function () {
    return new Date();
  }),
  type: Yup.string().required(),
  budget: Yup.number().required("Introduce un valor"),
  currency: Yup.string().required(),
  template: Yup.string().required(),
  projectType: Yup.string().required().min(3, "Selecciona un tipo antes de continuar")
});
var projectSchemaDefault = Yup.object().shape({
  projectType: Yup.string().required().min(3, "Selecciona un tipo antes de continuar")
});
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      "flex-wrap": "wrap"
    },
    mr30: {
      "margin-right": "30px"
    },
    flex: {
      display: "flex",
      "justify-content": "space-between"
    },
    w50: {
      width: "50%"
    },
    actions: {
      display: "flex",
      padding: "30px",
      "justify-content": "flex-end"
    }
  };
});

var DialogProject = function DialogProject(props) {
  var translation = props.translation,
      currency = props.currency,
      fromBestPractice = props.fromBestPractice,
      template = props.template; // console.log("DialogProject template", template);

  var _React$useState = React.useState(""),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      projectType = _React$useState2[0],
      setProjectType = _React$useState2[1];

  var classes = useStyles();
  var initialValues = {
    dateStart: null,
    dateEnd: null,
    statusExecution: "plan",
    template: fromBestPractice ? template.id : "",
    type: fromBestPractice ? template.type : ""
  };

  var handleTypeProject = function handleTypeProject(type) {
    setProjectType(type);
  };

  var fillFormHandler = function fillFormHandler(value, setFieldValue, values) {
    var selected = "";
    Object.keys(values).forEach(function (field) {
      if (field !== "status") {
        selected = props.opportunities.find(function (option) {
          return option.value === value;
        });
        if (selected) setFieldValue(field, selected[field]);
      }

      if (field === "projectType") {
        setFieldValue(field, values.projectType);
      }

      if (field === "source") {
        setFieldValue(field, values.source);
      }
    });
  };

  var title = "";

  if (props.variant === "edit") {
    title = "Editar Proyecto";
  } else if (props.variant === "view") {
    title = "Ver Proyecto";
  } else if (props.variant === "add") {
    title = "Añadir Proyecto";
  } // console.log("templates library", props.templates);


  return /*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    maxWidth: "md",
    title: title,
    open: props.open,
    onClose: props.onClose,
    mode: props.variant,
    key: 0
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: props.data || initialValues,
    validationSchema: projectType === "b2b" ? projectSchemaB2B : projectType === "b2c" ? projectSchemaB2C : projectSchemaDefault,
    onSubmit: function onSubmit(values) {
      props.createProject(values);
      props.onClose();
    },
    render: function render(_ref) {
      var values = _ref.values,
          setFieldValue = _ref.setFieldValue,
          isValid = _ref.isValid,
          isSubmitting = _ref.isSubmitting,
          errors = _ref.errors,
          touched = _ref.touched;
      return /*#__PURE__*/React.createElement(Form, {
        className: classes.form
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.root
      }, /*#__PURE__*/React.createElement(StepperHorizontal, {
        variant: "project",
        values: values,
        currency: currency,
        setFieldValue: setFieldValue,
        errors: errors,
        touched: touched,
        handleTypeProject: handleTypeProject,
        templates: props.templates,
        opportunities: props.opportunities,
        contacts: props.contacts,
        translation: translation ? translation : null,
        fillFormHandler: fillFormHandler,
        isValid: isValid,
        isSubmitting: isSubmitting,
        fromBestPractice: fromBestPractice,
        template: template
      })));
    }
  })));
};

export { DialogProject };